import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Form, Button, Navbar, Nav, Offcanvas, Badge, InputGroup } from 'react-bootstrap';
import { pega_nao_renovados } from "../../services/api";

const Alunos_nao_renovados = (props) => {
    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const meu_perfil = perfil[0].perfil;

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];
    const unidades_sigla = ['', 'BR', 'MD', 'SC', 'CD', 'TQ', 'NP', '', '', 'SP', 'BT', 'CG', 'CP', 'MG', 'MC', 'IG', 'FG', 'RB'];

    const navigate = useNavigate();

    // Estados
    const [data26, setData26] = useState([]);
    const [showFilters, setShowFilters] = useState(false);

    // Estados dos Filtros
    const [unidadeFiltro, setUnidadeFiltro] = useState("");
    const [filtroTurma, setFiltroTurma] = useState("");
    const [filtroNome, setFiltroNome] = useState("");
    const [filtroPlano, setFiltroPlano] = useState("");
    const [filtroTipoBolsa, setFiltroTipoBolsa] = useState("");
    const [filtroFinanceiro, setFiltroFinanceiro] = useState("todos");
    const [filtroAcademico, setFiltroAcademico] = useState("todos");

    const [bolsaMin, setBolsaMin] = useState(0);
    const [bolsaMax, setBolsaMax] = useState(100);

    const fetchData = async () => {
        try {
            const response = await pega_nao_renovados();
            const dadosUnicos = [...new Map(response.map(item => [item.matricula, item])).values()];
            setData26(dadosUnicos);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleLimparFiltros = () => {
        setUnidadeFiltro("");
        setFiltroTurma("");
        setFiltroNome("");
        setFiltroPlano("");
        setFiltroTipoBolsa("");
        setFiltroFinanceiro("todos");
        setFiltroAcademico("todos");
        setBolsaMin(0);
        setBolsaMax(100);
    };

    let userUnidades = [];
    if (meu_perfil === "GESTOR") {
        userUnidades = unidades_sigla.map((_, i) => i).filter(i => i > 0 && unidades_sigla[i]);
    } else if (meu_perfil.startsWith("DIRETOR") || meu_perfil.startsWith("SECRETARIA")) {
        const numerosString = meu_perfil.replace(/DIRETOR|SECRETARIA/, "").trim();
        userUnidades = numerosString.split("-").map(n => parseInt(n));
    }

    const filteredData = data26
        .filter(item => {
            const codUnidade = parseInt(item.unidade);
            if (!userUnidades.includes(codUnidade)) return false;

            if (unidadeFiltro && codUnidade !== parseInt(unidadeFiltro)) return false;
            if (filtroTurma && item.turma !== filtroTurma) return false;
            if (filtroNome && !item.nome.toLowerCase().includes(filtroNome.toLowerCase())) return false;
            if (filtroPlano && item.plano !== filtroPlano) return false;
            if (filtroTipoBolsa && item.tipo_bolsa !== filtroTipoBolsa) return false;

            // Filtro Pendência Financeira
            if (filtroFinanceiro === "sim" && !item.tipo_debito) return false;
            if (filtroFinanceiro === "nao" && item.tipo_debito) return false;

            // Filtro Pendência Acadêmica
            if (filtroAcademico === "sim" && !item.tipo_restricao) return false;
            if (filtroAcademico === "nao" && item.tipo_restricao) return false;

            const valorBolsa = parseFloat(item.bolsa || 0);
            if (valorBolsa < bolsaMin || valorBolsa > bolsaMax) return false;

            return true;
        })
        .sort((a, b) => {
            if (a.unidade !== b.unidade) return a.unidade - b.unidade;
            if (a.turma !== b.turma) return a.turma.localeCompare(b.turma);
            return a.nome.localeCompare(b.nome);
        });

    const totalAlunos = filteredData.length;
    const bolsaMedia = totalAlunos > 0
        ? (filteredData.reduce((acc, curr) => acc + parseFloat(curr.bolsa || 0), 0) / totalAlunos).toFixed(2)
        : 0;

    const handleExportCSV = () => {
        const header = ['UNIDADE', 'MATRICULA', 'FINANCEIRO', 'ACADEMICO', 'NOME', 'TURMA', 'PLANO', 'TIPO DE BOLSA', 'BOLSA', 'RESPONSAVEL FINANCEIRO', 'EMAIL RESPONSAVEL'];
        const rows = filteredData.map(item => [
            unidades[parseInt(item.unidade)],
            item.matricula,
            item.tipo_debito ? 'SIM' : 'NAO',
            item.tipo_restricao ? 'SIM' : 'NAO',
            item.nome,
            item.turma,
            item.plano || '',
            item.tipo_bolsa || '',
            `${item.bolsa || 0}%`,
            item.resp_finan || '',
            item.email_resp_finan || ''
        ]);

        const csvContent = "data:text/csv;charset=utf-8,\uFEFF"
            + [header, ...rows].map(e => e.join(",")).join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "alunos_nao_renovados.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const turmasDisponiveis = [...new Set(data26.map(item => item.turma))].filter(Boolean).sort();
    const planosDisponiveis = [...new Set(data26.map(item => item.plano))].filter(Boolean).sort();
    const tiposBolsaDisponiveis = [...new Set(data26.map(item => item.tipo_bolsa))].filter(Boolean).sort();

    return (
        <div style={{ paddingBottom: '80px' }}>
            <Navbar sticky="top" className="bg-body-tertiary px-3 shadow-sm">
                <Button variant="outline-warning" onClick={() => setShowFilters(true)} className="me-3">
                    ☰ Filtros de Pesquisa
                </Button>
                <Nav.Link href="/" className="me-auto d-none d-md-block">Santa Mônica Rede de Ensino</Nav.Link>
                <Navbar.Brand className="me-auto fs-6 fw-bold text-dark px-2">NÃO RENOVADOS</Navbar.Brand>

                <Form className="d-flex gap-2">
                    {meu_perfil === "GESTOR" && (
                        <Form.Select size="sm" value={unidadeFiltro} onChange={(e) => setUnidadeFiltro(e.target.value)}>
                            <option value="">Todas Unidades</option>
                            {userUnidades.map(cod => <option key={cod} value={cod}>{unidades[cod]}</option>)}
                        </Form.Select>
                    )}
                    <Button variant="danger" size="sm" onClick={() => navigate("/login")}>Sair</Button>
                </Form>
            </Navbar>

            <Offcanvas show={showFilters} onHide={() => setShowFilters(false)} placement="start">
                <Offcanvas.Header closeButton className="bg-warning text-dark">
                    <Offcanvas.Title>Filtrar Não Renovados</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Nome do Aluno</Form.Label>
                            <Form.Control type="text" placeholder="Buscar por nome..." value={filtroNome} onChange={(e) => setFiltroNome(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Pendência Financeira</Form.Label>
                            <Form.Select value={filtroFinanceiro} onChange={(e) => setFiltroFinanceiro(e.target.value)}>
                                <option value="todos">Todos</option>
                                <option value="sim">Sim (Possui Débito)</option>
                                <option value="nao">Não</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Pendência Acadêmica</Form.Label>
                            <Form.Select value={filtroAcademico} onChange={(e) => setFiltroAcademico(e.target.value)}>
                                <option value="todos">Todos</option>
                                <option value="sim">Sim (Possui Restrição)</option>
                                <option value="nao">Não</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Turma</Form.Label>
                            <Form.Select value={filtroTurma} onChange={(e) => setFiltroTurma(e.target.value)}>
                                <option value="">Todas as Turmas</option>
                                {turmasDisponiveis.map(t => <option key={t} value={t}>{t}</option>)}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Plano</Form.Label>
                            <Form.Select value={filtroPlano} onChange={(e) => setFiltroPlano(e.target.value)}>
                                <option value="">Todos os Planos</option>
                                {planosDisponiveis.map(p => <option key={p} value={p}>{p}</option>)}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="fw-bold d-flex justify-content-between">
                                Faixa de Bolsa <Badge bg="primary">{bolsaMin}% - {bolsaMax}%</Badge>
                            </Form.Label>
                            <div className="mt-2">
                                <small className="text-muted">Mínimo: {bolsaMin}%</small>
                                <Form.Range min="0" max="100" step="5" value={bolsaMin} onChange={(e) => setBolsaMin(parseInt(e.target.value))} />
                                <small className="text-muted">Máximo: {bolsaMax}%</small>
                                <Form.Range min="0" max="100" step="5" value={bolsaMax} onChange={(e) => setBolsaMax(parseInt(e.target.value))} />
                            </div>
                        </Form.Group>

                        <hr />
                        <Button variant="secondary" className="w-100 mb-2" onClick={handleLimparFiltros}>Limpar Tudo</Button>
                        <Button variant="warning" className="w-100" onClick={() => setShowFilters(false)}>Aplicar Filtros</Button>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>

            <div className="container-fluid mt-3 px-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Lista de Alunos Sem Renovação</h5>
                    <Button variant="success" size="sm" onClick={handleExportCSV}>Exportar CSV</Button>
                </div>

                <div className="table-responsive">
                    <Table striped bordered hover size="sm" className="align-middle">
                        <thead className="table-dark text-center">
                            <tr>
                                <th>UNIDADE</th>
                                <th>MATRICULA</th>
                                <th>DÉB.</th>
                                <th>RESTR.</th>
                                <th>NOME</th>
                                <th>TURMA</th>
                                <th>PLANO</th>
                                <th>TIPO DE BOLSA</th>
                                <th>BOLSA</th>
                                <th>RESPONSÁVEL FINANCEIRO</th>
                                <th>EMAIL RESPONSÁVEL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, index) => {
                                const temPendencia = item.tipo_debito || item.tipo_restricao;
                                return (
                                    <tr key={index} style={temPendencia ? { color: 'red', fontWeight: 'bold', fontSize: '90%' } : { fontSize: '90%' }}>
                                        <td className="text-center">{unidades[parseInt(item.unidade)]}</td>
                                        <td>{item.matricula}</td>
                                        <td className="text-center">{item.tipo_debito ? '🔴' : ''}</td>
                                        <td className="text-center">{item.tipo_restricao ? '🟡' : ''}</td>
                                        <td>{item.nome}</td>
                                        <td className="text-center">{item.turma}</td>
                                        <td>{item.plano}</td>
                                        <td>{item.tipo_bolsa}</td>
                                        <td>{item.bolsa ? `${item.bolsa}%` : '0%'}</td>
                                        <td>{item.resp_finan}</td>
                                        <td className="small">{item.email_resp_finan}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>

            <footer className="fixed-bottom bg-dark text-white p-2 shadow-lg">
                <div className="container-fluid d-flex justify-content-around align-items-center">
                    <span>Total de Alunos: <Badge bg="primary">{totalAlunos}</Badge></span>
                    <span>Bolsa Média: <Badge bg="warning">{bolsaMedia}%</Badge></span>
                </div>
            </footer>
        </div>
    );
}

export default Alunos_nao_renovados;